var ARSkeleton = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['ar-skeleton', _vm.color],style:({
    opacity: 3 / (2 + _vm.level),
  }),attrs:{"ar-widget-id":"ar-skeleton","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-skeleton"}})},
staticRenderFns: [],
  name: 'ARSkeletion',

  props: {
    arWidgetMeta: String,
    level: {
      type: Number,
      default: 1,
      validator: (val) => val > 0,
    },
    color: {
      type: String,
      default: 'black',
      validator: (val) => ['white', 'black'].indexOf(val) > -1,
    },
  },

  computed: {
    computedArWidgetMeta() {
      return [].join('');
    },
  },

  methods: {
  },
};

export default ARSkeleton;
